import React from "react";
import { observer, inject } from "mobx-react";
import CollapseFiltersContainer from "Containers/CollapseFiltersContainer";
import { SelectField } from "ComponentsUI/Selectfield";
import Routes from "Configs/routes";
import { withRouter } from "react-router-dom";
import FiltersLoadParams from "HOC/FiltersLoadParams";
import { generateUrl } from "Services/withDefaultParams";
import queryString from "query-string";
import { FiltersLayout, FiltersItem } from "ComponentsUI/Filters";

@withRouter
@inject("ApplicationModel")
@observer
export default class Filters extends FiltersLoadParams {
	constructor(props) {
		super(props);
		this.state = {
			periodFilter: "",
			serviceFilter: "",
		};
		let text = props.ApplicationModel.text;
		this.periods = [
			{
				id: 1,
				name: text.MONTHS_3,
			},
			{
				id: 2,
				name: text.MONTHS_6,
			},
			{
				id: 3,
				name: text.MONTHS_12,
			},
			{
				id: 4,
				name: text.ALL_TIME,
			},
		];
	}

	onFilter(filter) {
		const {
			match: { params },
			location: { search },
			history,
		} = this.props;
		const getParams = queryString.parse(search);
		let filterArr = [];
		let periodIds = [];
		let serviceIds = [];

		if (filter.period) {
			filter.period.map((item) => {
				periodIds.push(item.id);
			});
			getParams.period = periodIds.join(",");
		}

		if (filter.service) {
			filter.service.map((item) => {
				serviceIds.push(item.id);
			});
			getParams.service = serviceIds.join(",");
		}

		for (let key in getParams) {
			if (getParams[key]) {
				filterArr.push(`${key}=${getParams[key]}`);
			}
		}

		const ratingUrl = generateUrl(Routes.Rating.route, {
			regionUrl: params.regionUrl,
		});

		history.push({
			pathname: ratingUrl,
			search: filterArr.length ? `?${filterArr.join("&")}` : "",
		});
	}

	onResetFilters() {
		this.onFilter({
			period: [],
			service: [],
		});
	}

	render() {
		const { periods } = this;
		let {
			aggregation: { order_types },
		} = this.props;

		let period = this.periodInitFromGetParams(periods);

		let orderTypesFinded = this.servicesReviewsInitFromGetParams(order_types);

		order_types = order_types.sort((a, b) => a.id - b.id);

		if (!orderTypesFinded.length) {
			orderTypesFinded = order_types.filter((x) => x.id == 1);
		}

		let text = this.props.ApplicationModel.text;

		let windowSizes = this.props.ApplicationModel.windowSizeModel.windowSizes;

		return (
			<FiltersLayout>
				<CollapseFiltersContainer
					resetFiltersHandler={() => this.onResetFilters()}
					showResetButtonAfterFilterApply
				>
					<FiltersItem>
						<SelectField
							multiselect={false}
							items={periods}
							isFixedList={windowSizes.xs}
							windowSizes={windowSizes}
							onItemSelect={(items) =>
								this.onFilter({
									period: items,
								})
							}
							title={text.PERIOD}
							text={text}
							onlyInputDisabled={true}
							findItems={period}
							activePlaceHolder={text.SELECT_VALUE}
							placeholder={text.ALL_TIME}
							datatest="raiting_input_filter_period"
							whiteInput={true}
							onFocus={() => {
								this.props.ApplicationModel.mobileFiltersTouchModel.setFocus();
							}}
							onBlur={() => {
								this.props.ApplicationModel.mobileFiltersTouchModel.removeFocus();
							}}
							inputName="change_period"
						/>
					</FiltersItem>
					<FiltersItem>
						<SelectField
							multiselect={false}
							windowSizes={windowSizes}
							isFixedList={windowSizes.xs}
							items={order_types}
							onItemSelect={(items) =>
								this.onFilter({
									service: items,
								})
							}
							text={text}
							onlyInputDisabled={true}
							title={text.TENDER_INTERNET_SERVICE}
							findItems={orderTypesFinded}
							activePlaceHolder={text.SELECT_VALUE}
							placeholder={text.EVERYTHING}
							withoutClose={true}
							datatest="raiting_input_filter_internet_type"
							whiteInput={true}
							onFocus={() => {
								this.props.ApplicationModel.mobileFiltersTouchModel.setFocus();
							}}
							onBlur={() => {
								this.props.ApplicationModel.mobileFiltersTouchModel.removeFocus();
							}}
							inputName="change_services"
						/>
					</FiltersItem>
				</CollapseFiltersContainer>
			</FiltersLayout>
		);
	}
}
